module.exports = __webpack_public_path__ + "img/16581283_S.ad76b0f8.png";